export default (state = {
    AdditionalTypeId: null,
    ConservatoryTypeId: null,
    ConservatoryRoofMaterialId:null,
    ConservatoryColourId: null,
    ConservatoryColourInterior: null,
    ConservatoryColourWhiteInterior: null,
    WindowColourId: null,
    WindowColourWhiteInterior: null,
    WindowHandleColour: null,
    WindowHandleType: null,
    WindowStyleId: null,
    WindowSizeWidth: null,
    WindowSizeHeight: null,
    WindowSizeUnit: null,
    WindowSizeApproximate: null,
    WindowSizeType: null,
    WindowLock: null,
    DoorTypeId: null,
    DoorModelId: null,
    DoorCompositeColourId: null,
    DoorCompositeWhiteInterior: null,
    DoorCompositeHandleColour: null,
    DoorCompositeHandleType: null,
    DoorCompositeStyleId: null,
    DoorCompositeColourInteriorId: null,
    DoorCompositeColourExteriorId: null,
    DoorCompositeGlassId: null,
    DoorPvcColourId: null,
    DoorPvcWhiteInterior: null,
    DoorPvcHandleColour: null,
    DoorPvcHandleType: null,
}, action) => {
    switch (action.type) {
        case "UPDATE_PREVIOUS_SELECTION":
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/previousSelection_reducer.js